import { styled } from '@mui/material/styles'
import { TextInput } from 'ra-ui-materialui'
import React from 'react'
import VatCodeInput from 'ui-shared/WrappedInputs/VatCodeInput'

const PREFIX = 'PecSdiVatForm'

const classes = {
  dFlex: `${PREFIX}-dFlex`,
  width: `${PREFIX}-width`,
}

const Root = styled('div')({
  [`&.${classes.dFlex}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
  },
  [`& .${classes.width}`]: {
    width: '256px',
  },
})

const PecSdiVatForm: React.FC = () => {
  return (
    <Root className={classes.dFlex}>
      <VatCodeInput />
      <TextInput
        className={classes.width}
        source="pec"
        label="form.fields.pec"
      />
      <TextInput
        className={classes.width}
        source="sdi"
        label="form.fields.sdi"
      />
    </Root>
  )
}

export default PecSdiVatForm
